export function actionGenerator(type) {
  return function (payload) {
    return {
      type: type,
      payload: payload
    };
  };
}